import { render } from "./CheckoutSuccess.vue?vue&type=template&id=9b78a968"
import script from "./CheckoutSuccess.vue?vue&type=script&lang=js"
export * from "./CheckoutSuccess.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__